import React, { useEffect, useState } from "react";
import { Box, Button, Modal, useToast } from "fds";
import "./index.scss";
import { Workgroup } from "../../types/workgroup";
import { handleExitWorkgroup } from "../../shared/utils/api";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";

interface LeaveWorkgroupModalProps {
  open: boolean;
  onClose: () => void;
  submtiAfter?: () => void;
  withdrawMember: any;
  workgroupInfo?: Workgroup;
}
const LeaveWorkgroupModal: React.FC<LeaveWorkgroupModalProps> = ({
  open,
  onClose,
  submtiAfter,
  withdrawMember,
  workgroupInfo,
}) => {
  const toast = useToast();
  const navigate = useNavigate();
  const { workgroupState, checkCheckoutUser, getWorkgroupSideList } =
    useWorkgroupStore();
  const [step, changeStep] = useState(-1);
  useEffect(() => {
    const user = getUserInfoFromLocalStorage() as string | "";
    const loginDto: LoginDto = JSON.parse(user);
    const myId = loginDto?.userInfo?.userId ?? "";
    checkCheckoutUser([myId], workgroupInfo?.workgroupId).then((resp: any) =>
      changeStep(resp.payload && resp.payload.length > 0 ? 1 : 0)
    );
  }, []);
  return (
    <Modal
      open={open}
      onClose={onClose}
      width={540}
      title={
        step === 0
          ? t("workgroup.leaveWorkgroupTitle")
          : step === 1
          ? t("workgroup.editWarningTitle")
          : undefined
      }
      bodyMsg={
        step === 0
          ? t("workgroup.leaveWorkgroupBody")
          : step === 1
          ? t("workgroup.editWarningBody")
          : undefined
      }
      footer={
        <Box>
          <Button
            btnStyle="fill"
            type="secondary"
            label={t("common.cancel")}
            onClick={onClose}
          />
          <Button
            btnStyle="fill"
            label={step === 0 ? t("workgroup.exit") : t("common.confirm")}
            type={"error"}
            state={step === -1 ? "disable" : "hover"}
            onClick={() => {
              if (step === 1) changeStep(0);
              else {
                handleExitWorkgroup(
                  withdrawMember,
                  toast,
                  navigate,
                  () => {
                    onClose();
                  },
                  workgroupInfo,
                  getWorkgroupSideList,
                  workgroupState.savedSidemenuFilter
                );
                submtiAfter && submtiAfter();
              }
            }}
          />
        </Box>
      }
    />
  );
};
export default LeaveWorkgroupModal;
